import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const crudReducer = (state: RootState) => state.private.crud;

export const crudProjectSelector = createSelector(crudReducer, (crud) => crud.project);
export const filtriCrudSelector = createSelector(crudReducer, (crud) => crud.crudFilters);
export const crudCategoriesSelector = createSelector(crudReducer, (crud) => crud.crudCategories);
